export enum ReportsList {
  SALE_CONSULTING_PROPERTY_CUSTOMER_DATA = 1,
  LEASE_PROPERTY_CUSTOMER_DATA,
  DSF_ENGAGEMENT_CUSTOMER_DATA,
  SALE_DSF_CONSULTING_FEE_CALCULATION,
  LEASE_FEE_CALCULATION,
  LEASE_INCENTIVES,
  LEASE_RENT_REVIEW,
  LEASE_TENANT_PRIOR_LOCATION,
  FEE_SPLITS,
  EXPENSE_DISBURSEMENTS,
  FEE_INFLUENCER,
  DEAL_FILE_CHECKLIST,
  YTD_SUMMARY = 20,
  YTD_SUMMARY_FINANCE = 21,
  YTD_SUMMARY_COMPANY_INCOME = 23,
  VALUATION_ENGAGEMENT_CUSTOMER_DATA = 24,
  VALUATION_SUMMARY_REPORTS = 17,
  VALUATION_PROPERTY_CUSTOMER_DATA = 19,
}
